import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "license";
const license = createEndpointBase(base);

const ScriptReplaysUsageSchema = z.object({
  scriptReplaysCount: z.number(),
  limitResetAt: z.string(),
});

export const licenseEndpoints = {
  licenseGet: license({ method: "GET", path: "", request: z.any(), response: z.any() }),
  licenseInstall: license({
    method: "POST",
    path: "id",
    request: z.object({ licenseId: z.string() }),
    response: z.any(),
  }),
  licenseScriptReplaysUsage: license({
    method: "GET",
    path: "script-replays-usage",
    request: z.looseObject({}),
    response: ScriptReplaysUsageSchema,
  }),
} as const;
